<script>
    import { stylesColors, stylesList } from '../../helpers/style.helper';

    export let value = null;

    let val = value;

    try {
        val = val ? JSON.parse(value) : JSON.parse(stylesList[4]);
    } catch(e) {
        val = defaultValue;
    }

    function onChange() {
        value = JSON.stringify(val);
    }

    $: val, onChange();

</script>

<div class="form-group row">
    <div class="col-4 offset-4">
        Color
    </div>
</div>

<div class="form-group row">
    <div class="col-4  text-right">
        <label>Empty:</label>
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.emptyColor}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.emptyColor }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color}"
                        on:click={() => val.emptyColor = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<div class="form-group row">
    <div class="col-4 range">
        +-
        <input class="form-control" type="number" bind:value={val.range1} on:click={onChange}>
        %
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.range1_color}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.range1_color }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color} "
                        on:click={() => val.range1_color = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<div class="form-group row">
    <div class="col-4 range">
        +-
        <input class="form-control" type="number" bind:value={val.range2} on:click={onChange}>
        %
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.range2_color}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.range2_color }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker style-{val.range2_color}">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color}"
                        on:click={() => val.range2_color = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<div class="form-group row">
    <div class="col-4 text-right">
        <label>Else:</label>
    </div>
    <div class="col-4">
        <div class="dropdown color-scheme-picker">
            <button class="form-control btn-default btn-block dropdown-toggle text-capitalize style-{val.else_color}"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                { val.else_color }
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu color-scheme-panel" aria-labelledby="dropdown-color-picker">
                <li class="dropdown-header text-uppercase">Choose a color</li>
                <li role="separator" class="divider"></li>
                {#each stylesColors as color}
                    <li class="p-2 text-capitalize style-{color}"
                        on:click={() => val.else_color = color}>
                        {color}
                    </li>
                {/each}
            </ul>
        </div>
    </div>
</div>

<style>
    .range > input{
        display: inline-block;
        margin: 0px 10px;
        width: 70px;
    }
</style>